// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import 'es6-promise/auto';
import { sync } from 'vuex-router-sync';
import Vue from 'vue';
import { DropdownPlugin, ModalPlugin, CarouselPlugin } from 'bootstrap-vue';
import VueLocalStorage from 'vue-localstorage';
import 'swiper/dist/css/swiper.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';

import VueAnalytics from 'vue-analytics';
import 'material-design-lite';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/styles/main.scss';

import { GA_ID } from './config';
import AppRoot from './AppRoot';

import httpPlugin from './plugins/http';
import mobilePlugin from './plugins/mobile';

import MyDirectives from './directives';
import MyComponents from './components';
import router from './router';
import i18n from './i18n';
import store from './store';

Vue.config.productionTip = false;

Vue.use(VueAwesomeSwiper);
Vue.use(VueLocalStorage);
Vue.use(DropdownPlugin);
Vue.use(ModalPlugin);
Vue.use(CarouselPlugin);
Vue.use(httpPlugin, { store, router });
Vue.use(mobilePlugin);
Vue.use(VueAnalytics, {
  id: GA_ID,
  router,
  autoTracking: {
    pageviewOnLoad: false,
  },
  ignoreRoutes: ['auth'],
});

Vue.use(MyDirectives);
Vue.use(MyComponents);

sync(store, router);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  el: '#app',
  template: '<AppRoot/>',
  components: { AppRoot },
});



// WEBPACK FOOTER //
// ./src/main.js